import * as React from "react";
import { DocumentRequestStatus } from "../../../../../../../Wrap/Constants/Enums/Domain/DocumentRequestStatus";
import { TaskRequestStatus } from "../../../../../../../Wrap/Constants/Enums/Tasks/TaskRequestStatus";
import { EncryptedInstructionDocumentTypeRequest } from "../../../../../../../Wrap/Models/Models/Documents/InstructionDocuments/EncryptedInstructionDocumentTypeRequest";
import { TaskRequestStatusModel } from "../../../../../../../Wrap/Models/Models/Tasks/TaskRequestStatusModel";
import { ExcelExportAction } from "../../../../../../Shared/ExcelExport/Actions/ExcelExportAction";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { getQueryParameters } from "../../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { DocumentFileAction } from "../../../PortfolioDashboard/Components/Document/Action/DocumentFileAction";
import { SectionHeader } from "../../SharedComponents";
import { IllustrationStore } from "../Store/Variable";

interface IIllustrationsAvailableProps extends IProcessComponentProps {
    data: any;
}

interface IIllustrationsAvailableState {
    illustrations: EncryptedInstructionDocumentTypeRequest[];
    downloadedOrFailed: number[];
}

export class IllustrationsAvailable extends ProcessComponent<
    IIllustrationsAvailableProps,
    IIllustrationsAvailableState
> {
    constructor(props: any) {
        super(props);
        this.state = {
            illustrations: IllustrationStore.getData(),
            downloadedOrFailed: [],
        };
        this.subscribeToStore(IllustrationStore, () => this.onStoreChange());
    }

    private onStoreChange() {
        const data = IllustrationStore.getData();
        this.setState({ illustrations: IllustrationStore.getData() }, () => {
            (data || []).forEach((illustration) => {
                this.getStatus(illustration);
            });
        });
    }

    componentWillUnmount() {
        clearInterval(this.illustrationSetTimeout);
    }

    private illustrationSetTimeout;
    private getStatus(illustration: EncryptedInstructionDocumentTypeRequest) {
        ExcelExportAction.getTaskRequestStatus(
            illustration?.DocumentRequest?.Id?.toString(),
            (res: TaskRequestStatusModel) => {
                const status = res.Status;
                if (
                    status == TaskRequestStatus.Pending ||
                    status == TaskRequestStatus.Running ||
                    status == TaskRequestStatus.Allocated ||
                    status == TaskRequestStatus.PendingDelayed ||
                    status == TaskRequestStatus.PendingHold
                ) {
                    this.illustrationSetTimeout = setTimeout(() => {
                        this.getStatus(illustration);
                    }, 2000);
                } else if (status == TaskRequestStatus.Complete) {
                    const params = getQueryParameters();
                    DocumentFileAction.get(
                        null,
                        illustration?.DocumentType.Name + ".PDF",
                        true,
                        0,
                        illustration?.DocumentRequest?.Id,
                        params["claccountid"],
                        (result: string) => {
                            const { illustrations } = this.state;
                            illustrations.find(
                                (ele) => ele?.DocumentRequest?.Id == illustration?.DocumentRequest?.Id
                            ).DocumentRequest.Status = DocumentRequestStatus.Completed;
                            illustrations.find(
                                (ele) => ele?.DocumentRequest?.Id == illustration?.DocumentRequest?.Id
                            ).DocumentRequest["Url"] = result;
                            this.setState((preState) => {
                                return {
                                    downloadedOrFailed: preState.downloadedOrFailed.concat(
                                        illustration?.DocumentRequest?.Id
                                    ),
                                };
                            });
                        }
                    );
                } else {
                    const { illustrations } = this.state;
                    illustrations.find(
                        (ele) => ele?.DocumentRequest?.DocumentTypeId == illustration?.DocumentRequest?.DocumentTypeId
                    ).DocumentRequest.Status =
                        status == TaskRequestStatus.Failed
                            ? DocumentRequestStatus.Failed
                            : DocumentRequestStatus.Cancelled;
                    this.setState((preState) => {
                        return {
                            downloadedOrFailed: preState.downloadedOrFailed.concat(
                                illustration?.DocumentRequest?.DocumentTypeId
                            ),
                        };
                    });
                }
            }
        );
    }

    private renderIllustrationsAvailable() {
        return (
            <>
                {SectionHeader("Illustrations available")}
                {this.renderDocAvailableTable()}
            </>
        );
    }

    private renderDocAvailableTable() {
        const illustrations = this.state.illustrations || [];
        return (
            <div>
                {illustrations.map((row) => (
                    <div className="mb-24 flex-line" key={row.InstructionId}>
                        <p>{`${row.DocumentType.Name} ${row.DocumentRequest?.Id}`}</p>

                        {row?.DocumentRequest?.Status == DocumentRequestStatus.Completed ? (
                            <a
                                type="button"
                                className="download-button label-sr-only ml-20"
                                target={"_blank"}
                                href={row?.DocumentRequest?.["Url"]}
                            >
                                <span className="icon" aria-hidden="true"></span>
                                <span className="text">{`${row?.DocumentType?.Name} ${row?.DocumentRequest?.Id}`}</span>
                            </a>
                        ) : row?.DocumentRequest?.Status == DocumentRequestStatus.Pending ? (
                            <span className="lds-dual-ring label-sr-only ml-20"></span>
                        ) : (
                            <span className="text-negative ml-20">Failed or Cancelled</span>
                        )}
                    </div>
                ))}
            </div>
        );
    }

    render() {
        return <>{this.renderIllustrationsAvailable()}</>;
    }
}
